/** TutorCloud teacher accessibility helpers (aligned with ProfileSettings). */

export function normalizeTeacherAccessibility(accessibility) {
  const acc = accessibility && typeof accessibility === "object" ? accessibility : {};
  return {
    textSize: acc.textSize || "Medium (Default)",
    themeMode: acc.themeMode || "Light",
    contrastMode: acc.contrastMode || "Standard",
  };
}

export function teacherTextSizeToPx(textSize) {
  if (textSize == null) return 16;
  const s = String(textSize).toLowerCase();
  if (s.includes("extra large")) return 22;
  if (s.includes("large") && !s.includes("medium")) return 18;
  if (s.includes("small")) return 14;
  const n = Number(textSize);
  if (Number.isFinite(n) && n > 0) {
    if (n <= 14) return 14;
    if (n >= 22) return 22;
    return Math.round(n);
  }
  return 16;
}

export function resolveTeacherThemeAttribute(accessibility, isSystemDark) {
  const contrast = String(accessibility?.contrastMode || "Standard");
  if (contrast === "High" || contrast === "Extra High") return "high-contrast";
  const mode = String(accessibility?.themeMode || "Light");
  if (mode === "Dark") return "dark";
  if (mode === "Auto") return isSystemDark ? "dark" : "light";
  return "light";
}
